import React from "react";
import { theme, Layout, Flex, Space, Button, Tag } from "antd";
import strings from "resources/strings";
import CONSTANTS from "shared/constants";
import moment from "moment";
const { Footer } = Layout;

export default function FooterContent() {
  const { token: theme_token } = theme.useToken();

  const EnvTag = () =>
    CONSTANTS.LOCAL ? (
      <Tag color="red" style={{ marginBottom: "10px" }}>
        LOCAL
      </Tag>
    ) : CONSTANTS.DEV ? (
      <Tag color="orange" style={{ marginBottom: "10px" }}>
        DEV
      </Tag>
    ) : (
      // <Tag color="purple" style={{ marginBottom: "10px" }}>
      //   BETA
      // </Tag>
      <></>
    );

  return (
    <Footer>
      <Flex
        justify="center"
        align="center"
        vertical
        gap={0}
        style={{ marginBottom: "10px" }}
      >
        <EnvTag />
        <Space size={2}>
          &copy; {moment().year()} • {strings.appName}
        </Space>
        <Space size={0}>
          <Button
            type="link"
            href={strings.urlTerms}
            target="_blank"
            style={{ color: theme_token.colorSecondary }}
          >
            {strings.titleTerms}
          </Button>
          |
          <Button
            type="link"
            href={strings.urlPrivacy}
            target="_blank"
            style={{ color: theme_token.colorSecondary }}
          >
            {strings.titlePrivacy}
          </Button>
        </Space>
      </Flex>
    </Footer>
  );
}
